import styled from "styled-components";

const Heading1Styles = styled.h1`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.heading.h3.weight};
  font-size: ${({ theme }) => theme.typography.heading.h3.size};
  line-height: ${({ theme }) => theme.typography.heading.h3.lineHeight};
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const Heading1 = ({ children, className, style }) => (
  <Heading1Styles className={className} style={{ ...style }}>
    {children}
  </Heading1Styles>
);

export default Heading1;
